
//accordion hulk product options
document.addEventListener('click',(event) => {
    var isOpen;
    if(event.target.closest('.hulkapps_option_name') != null ){
      let toggleButton = event.target.closest('.hulkapps_option_name')
      let toggleContent = event.target.closest('.hulkapps_option_name').nextElementSibling;

      if(event.target.nextSibling != null )
        isOpen = event.target.closest('.hulkapps_option_name').nextElementSibling.classList.contains('h-auto');
        isOpen ? closeAccordionBlock(toggleButton,toggleContent) : openAccordionBlock(toggleButton,toggleContent)
      }

    if(event.target.closest('.edit_cart_option')){
          let productId = event.target.getAttribute('data-product_id');;
          let selectedOption;
          setTimeout(() => {
            let customOptions =  document.querySelector(`#hulkapps_custom_options_${productId}`);
            console.log(customOptions,"customOptions======") 
            
            if( customOptions != null ){
          
              customOptions.querySelectorAll('input[type=radio],select,input[type=text]').forEach( ele => {
                ele.addEventListener('change',(event) => {
                  selectedOption = event.target.value;
                  let selectedWrapper = event.target.closest('.hulkapps_option').querySelector('.hulkapps_option_name');
                  if(selectedWrapper.querySelectorAll('.selected_option_select').length < 1)
                    selectedWrapper.insertAdjacentHTML('beforeend', '<span class="selected_option_select"></span>');
                    selectedWrapper.querySelector('.selected_option_select').innerHTML = `<span>${selectedOption.replace("$","+$")}</span>`
                })
              })
              customOptions.querySelectorAll('.hulkapps_option_name').forEach( ele => {
                if(ele.querySelector('.hulkapps-required') == null )
                {
                  ele.classList.add('optional') 
                }
                else{
                  ele.classList.add('required')
                }
              })
            }
          }, 3000)
        
    }


    }
)

//open accordion block
openAccordionBlock = (toggleButton,toggleContent) =>{
  console.log("open block")
 toggleContent.classList.add('h-auto');
 if(toggleButton.closest('.accordion-container') != null)
    toggleButton.closest('.accordion-container').classList.add('open')

  if(toggleButton.closest('.hulkapps_option') != null)
     toggleButton.closest('.hulkapps_option').classList.add('open')
}

//close accordion block
closeAccordionBlock = (toggleButton,toggleContent) =>{
console.log("close block")
 toggleContent.classList.remove('h-auto')
 if(toggleButton.closest('.accordion-container') != null)
   toggleButton.closest('.accordion-container').classList.remove('open')

  if(toggleButton.closest('.hulkapps_option') != null)
    toggleButton.closest('.hulkapps_option').classList.remove('open')

}

